import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    user: null,
    token: null,
    isLogging: false
}

export const authSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
        },

        setToken: (state, action) => {
            state.token = action.payload
        },

        loginUser: (state, action) => {
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.isLogging = false;
        }
    },
});

// Action creators are generated for each case reducer function
export const {setUser, setToken, loginUser} = authSlice.actions

export default authSlice.reducer
